import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import * as React from 'react';

import NewActivityTable from './new-activity-table';

export default function NewActivityTables({
  parentIndex,
}: {
  parentIndex: number;
}) {
  const name = `activitySales.${parentIndex}`;
  const _values = HOCWatchValue({ keys: [name] });
  const { activitySaleGuests } = _values[name];

  return (
    <>
      <Separator gap={16} />
      {activitySaleGuests
        .filter((curr) => !!curr.guestId)
        .map((field, idx) => (
          <>
            <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
            <Separator gap={8} />
            <NewActivityTable
              guestIdx={idx}
              parentIndex={parentIndex}
              isSelected={field.isSelected}
            />
            <Separator gap={24} />
          </>
        ))}
    </>
  );
}
